"use strict";

let dealerSearchBox, dealerMap, infoWindow;
let markersArray = [];

jQuery(document).ready(function ($) {

    $(document).foundation();

    $(".Menu-toggle").on("click", function () {
        $(this).toggleClass("collapsed");
        $('.Header-offcanvasMenu').toggleClass('js-active');
    });

    $("body").on("click", ".js-off-canvas-overlay", function () {
        $(".Menu-toggle").toggleClass("collapsed");
    });

    $(".Header-mobileDealer").on("click", function () {
        $(".Header-mobileDealerWrapper").toggleClass("js-active");
    });

    $(".Header-mobileSearch").on("click", function () {
        $(".Header-mobileSearchWrapper").toggleClass("js-active");
        $('.Header-offcanvasMenu').removeClass('js-active');
        $('.Menu-toggle').addClass('collapsed');
        $('.Header-mobileSearchInput').focus();
    });

    $(document).on("click", ".VideoSlider-image", function () {
        let id = $(this).attr('data-imagevideoid');

        $('.VideoSlider-video').each(function() {
            if($(this).attr('data-videoid') === id) {
                $(this).parent().addClass('js-active');
                $(this).addClass('js-active');
            }
        });
    });

    $(".VideoSlider-close").on("click", function () {
        $(".VideoSlider-modal").removeClass("js-active");
        $(".VideoSlider-video").removeClass("js-active");
        $(this).parent('.VideoSlider-modal').find('media-player').each(function() {
            this.pause();
        });
    });

    let isGoingFullscreen = false;

    $(document).on("fullscreenchange", function () {
        if (document.fullscreenElement) {
            $('.VideoPlay-playButton').addClass('js-active');
            $('.VideoPlay-video .vds-video-layout .vds-controls-group').addClass('js-active');
            $('.VideoSlider-video .vds-video-layout .vds-controls-group').addClass('js-active');
            isGoingFullscreen = true;
        }
    });

    $(".VideoPlay-video, .VideoSlider-video").on("click", function (e) {
        let player = $(this).find("media-player")[0];

        if (player) {
            let state = player.state;

            if (state?.playing) {
                if (!isGoingFullscreen) {
                    $('.VideoPlay-playButton').removeClass('js-active');
                    $('.VideoPlay-video .vds-video-layout .vds-controls-group').removeClass('js-active');
                    $('.VideoSlider-video .vds-video-layout .vds-controls-group').removeClass('js-active');
                }
            } else {
                $('.VideoPlay-playButton').addClass('js-active');
                $('.VideoPlay-video .vds-video-layout .vds-controls-group').addClass('js-active');
                $('.VideoSlider-video .vds-video-layout .vds-controls-group').addClass('js-active');
            }
        }
    });


    if ($('.grid').length) {
        $('.grid-overview').simpleLoadMore({
            count: 6,
            item: '.grid-item'
        });

        var $grid = $('.grid').masonry({
            columnWidth: '.grid-sizer',
            itemSelector: '.grid-item'
        });
    }

    if ($('.grid-masonry').length) {
        $('.grid-masonry').simpleLoadMore({
            count: 7,
            item: '.grid-masonry-item',
            btnHTML: '<div class="loadMore-row load-more__btn"><a href="#" class="load-more__btn">Load more articles</a></div>'
        });

        var $grid = $('.grid-masonry').masonry({
            columnWidth: '.grid-sizer',
            itemSelector: '.grid-masonry-item',
        });
    }

    $(document).on('click', '.load-more__btn', function () {
        $grid.masonry('layout');
    });

    $(".ProductSlider").each(function () {
        let swiper = new Swiper(this, {
            slidesPerView: 1,
            loop: true,
            breakpoints: {
                560: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                758: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                },
                868: {
                    slidesPerView: 4,
                    spaceBetween: 25,
                },
                1600: {
                    slidesPerView: 5,
                    spaceBetween: 25,
                },
            },
            navigation: {
                nextEl: ".ProductSlider-buttonNext",
                prevEl: ".ProductSlider-buttonPrev",
            },
        });

        $(".ProductSlider-slider").mouseenter(function () {
            swiper.autoplay.stop();
        });
        $(".ProductSlider-slider").mouseleave(function () {
            swiper.autoplay.start();
        });
    });

    $(".RelatedProductSlider").each(function () {
        let swiper = new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 25,
            breakpoints: {
                560: {
                    slidesPerView: 2,
                },
                758: {
                    slidesPerView: 3,
                },
                868: {
                    slidesPerView: 4,
                },
                1600: {
                    slidesPerView: 5,
                },
            },
            navigation: {
                nextEl: ".RelatedProductSlider-buttonNext",
                prevEl: ".RelatedProductSlider-buttonPrev",
            },
        });

        $(".RelatedProductSlider-slider").mouseenter(function () {
            swiper.autoplay.stop();
        });
        $(".RelatedProductSlider-slider").mouseleave(function () {
            swiper.autoplay.start();
        });
    });

    $(".DealerSlider").each(function () {
        let swiper = new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 20,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            breakpoints: {
                450: {
                    slidesPerView: 1,
                },
                550: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1440: {
                    slidesPerView: 4,
                },

            },
            navigation: {
                nextEl: ".DealerSlider-buttonNext",
                prevEl: ".DealerSlider-buttonPrev",
            },
        });

        $(".DealerSlider-slider").mouseenter(function () {
            swiper.autoplay.stop();
        });
        $(".DealerSlider-slider").mouseleave(function () {
            swiper.autoplay.start();
        });
    });





    if ($(".HeroSlider-slider").length > 0) {
        let $i = 0;
        $(".HeroSlider-slider").each(function () {
            $(this).addClass('HeroSlider-slider-' + $i);
            $(".HeroSlider-buttonNext").addClass("HeroSlider-buttonNext" + $i);
            $(".HeroSlider-buttonPrev").addClass("HeroSlider-buttonPrev" + $i);
            $(".HeroSlider-pagination--horizontal").addClass("HeroSlider-pagination--horizontal" + $i);
            new Swiper(".HeroSlider-slider-" + $i, {
                slidesPerView: 1,
                speed: 1000,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".HeroSlider-buttonNext" + $i,
                    prevEl: ".HeroSlider-buttonPrev" + $i,
                },
                pagination: {
                    el: '.HeroSlider-pagination--horizontal' + $i,
                    clickable: true,
                },
            });
            $(".HeroSlider-slider" + $i).mouseenter(function () {
                swiper.autoplay.stop();
            });
            $(".HeroSlider-slider" + $i).mouseleave(function () {
                swiper.autoplay.start();
            });
            $i++;
        });
    }

    if ($(".HighlightedProductSlider-slider").length > 0) {
        let HighlightedProductSlider = $(".HighlightedProductSlider-slider"),
            i = 0;

        HighlightedProductSlider.each(function () {
            HighlightedProductSlider.addClass("HighlightedProductSlider-slider" + i);
            $(".HighlightedProductSlider-buttonNext").addClass("HighlightedProductSlider-buttonNext" + i);
            $(".HighlightedProductSlider-buttonPrev").addClass("HighlightedProductSlider-buttonPrev" + i);
            let swiper = new Swiper(this, {
                slidesPerView: 1,
                speed: 1000,
                loop: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".HighlightedProductSlider-buttonNext" + i,
                    prevEl: ".HighlightedProductSlider-buttonPrev" + i,
                },
            });
            $(".HighlightedProductSlider-slider" + i).mouseenter(function () {
                swiper.autoplay.stop();
            });
            $(".HighlightedProductSlider-slider" + i).mouseleave(function () {
                swiper.autoplay.start();
            });
            i++;
        });
    }

    if ($(".VideoSlider-slider").length > 0) {
        let VideoSlider = $(".VideoSlider-slider"),
            i = 0;

        VideoSlider.each(function () {
            VideoSlider.addClass("VideoSlider-slider" + i);
            $(".VideoSlider-buttonNext").addClass("VideoSlider-buttonNext" + i);
            $(".VideoSlider-buttonPrev").addClass("VideoSlider-buttonPrev" + i);
            let swiper = new Swiper(this, {
                slidesPerView: 1,
                spaceBetween: 10,
                speed: 1000,
                loop: true,
                navigation: {
                    nextEl: ".VideoSlider-buttonNext" + i,
                    prevEl: ".VideoSlider-buttonPrev" + i,
                },
            });
            i++;
        });
    }

    if ($(".HighlightBlockSlider-sliderTop").length > 0 && $(".HighlightBlockSlider-sliderBottom").length > 0) {
        let swiperTop = new Swiper(".HighlightBlockSlider-sliderTop", {
            slidesPerView: 1,
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".HighlightBlockSlider-buttonNext",
                prevEl: ".HighlightBlockSlider-buttonPrev",
            },
        });

        let swiperBottom = new Swiper(".HighlightBlockSlider-sliderBottom", {
            slidesPerView: 1,
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
        });

        swiperTop.controller.control = swiperBottom;
        swiperBottom.controller.control = swiperTop;

        $(".HighlightBlockSlider-sliderTop, .HighlightBlockSlider-sliderBottom").mouseenter(function () {
            swiperTop.autoplay.stop();
            swiperBottom.autoplay.stop();
        });

        $(".HighlightBlockSlider-sliderTop, .HighlightBlockSlider-sliderBottom").mouseleave(function () {
            swiperTop.autoplay.start();
            swiperBottom.autoplay.start();
        });
    }

    if ($(".ImageTextSlider").length > 0) {
        let ImageTextSlider = $(".ImageTextSlider"),
            i = 0;

            ImageTextSlider.each(function () {
                ImageTextSlider.addClass("ImageTextSlider-" + i);
            $(".ImageTextSlider-buttonNext").addClass("ImageTextSlider-buttonNext" + i);
            $(".ImageTextSlider-buttonPrev").addClass("ImageTextSlider-buttonPrev" + i);
            let swiper = new Swiper(this, {
                slidesPerView: 6,
                spaceBetween: 40,
                speed: 1000,
                loop: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".ImageTextSlider-buttonNext" + i,
                    prevEl: ".ImageTextSlider-buttonPrev" + i,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    550: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1080: {
                        slidesPerView: 5,
                        spaceBetween: 14,
                    },
                    1440: {
                        slidesPerView: 6,
                    },

                },
            });
            $(".ImageTextSlider-" + i).mouseenter(function () {
                swiper.autoplay.stop();
            });
            $(".ImageTextSlider-" + i).mouseleave(function () {
                swiper.autoplay.start();
            });
            i++;
        });
    }

    if ($(".CampaignSlider-slider").length > 0) {
        let CampaignSlider = $(".CampaignSlider-slider"),
            i = 0;

        CampaignSlider.each(function () {
            CampaignSlider.addClass("CampaignSlider-slider" + i);
            let swiper = new Swiper(this, {
                slidesPerView: 1,
                speed: 1000,
                loop: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
            });
            i++;
        });
    }

    $(".Slider").each(function () {
        let swiper = new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 25,
            breakpoints: {
                550: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1440: {
                    slidesPerView: 4,
                }
            },
            navigation: {
                nextEl: ".Slider-buttonNext",
                prevEl: ".Slider-buttonPrev",
            },
        });
        $(".Slider-slider").mouseenter(function () {
            swiper.autoplay.stop();
        });
        $(".Slider-slider").mouseleave(function () {
            swiper.autoplay.start();
        });
    });

    if ($('.ProductDetail-sliderTop') && $('.ProductSlider-sliderBottom')) {
        let galleryThumbs = new Swiper('.ProductDetail-sliderBottom', {
            spaceBetween: 10,
            slidesPerView: 2,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: ".ProductDetail-sliderBottom-buttonNext",
                prevEl: ".ProductDetail-sliderBottom-buttonPrev",
            },
            breakpoints: {
                550: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
                1440: {
                    slidesPerView: 5,
                }
            },
        });
        let galleryTop = new Swiper('.ProductDetail-sliderTop', {
            spaceBetween: 10,
            thumbs: {
                swiper: galleryThumbs,
            },
            navigation: {
                nextEl: ".ProductDetail-sliderTop-buttonNext",
                prevEl: ".ProductDetail-sliderTop-buttonPrev",
            },
        });
    }

    if ($('.Parallax').length) {
        let element = $(".Parallax"),
            blockHeight = element.height(),
            scroll,
            zoom,
            blockTop = element.offset().top;

        $(window).scroll(function (event) {
            scroll = $(window).scrollTop();

            if (scroll > blockTop && scroll < blockTop + blockHeight) {
                zoom = 1 + ((scroll - blockTop) / 1500);

                $(".Parallax-image").css("transform", "scale(" + zoom + ")");
                $(".Parallax-image").css("maxHeight", blockHeight + "px");
            }
        });
    }

    $('.Header-language-active').on('click', function () {
        $(this).toggleClass('js-active');
        $('.Header-languageList').toggleClass('js-active');
        $('.Header-offcanvasMenu').removeClass('js-active');
        $('.Menu-toggle').addClass('collapsed');
    });

    $('.file').each(function () {
        let $input = $(this).find('input');
        $input.change(function () {
            let input = $input.val().split("\\"),
                fileName = input[input.length - 1];
            $('head').append('<style>.file-custom:after{content: "' + fileName + '"}</style>');
        });
    });
    $('.Header-searchIcon').on('click', function () {
        $('.Header-searchForm').addClass('js-active');
        $('.Header-searchInput').focus();
        $('.Header-search').addClass('js-active');
    });

    $('.Header-searchClose').on('click', function () {
        $('.Header-searchForm').removeClass('js-active');
        $('.Header-search').removeClass('js-active');
    })

    const element = $('.Header-menu'),
        menuTop = $('.Header-topMenu').height();
    $(document).scroll(function () {
        const scroll = $(document).scrollTop();

        if (scroll > menuTop) {
            element.addClass('js-scroll');
        } else if (scroll < menuTop) {
            element.removeClass('js-scroll');
        }
    });

    $('.CookiePopUp-cookieState').on('click', function () {
        $('.CookiePopUp-cookiePolicy').toggleClass('js-active');
        $('.CookiePopUp-content').toggleClass('js-hide');
    });

    $('.CookiePopUp-cookiePolicy-back').on('click', function () {
        $('.CookiePopUp-cookiePolicy').toggleClass('js-active');
        $('.CookiePopUp-content').toggleClass('js-hide');
    });

    $('.CookiePopUp-privacyState').on('click', function () {
        $('.CookiePopUp-privacyPolicy').toggleClass('js-active');
        $('.CookiePopUp-content').toggleClass('js-hide');
    });

    $('.CookiePopUp-privacyPolicy-back').on('click', function () {
        $('.CookiePopUp-privacyPolicy').toggleClass('js-active');
        $('.CookiePopUp-content').toggleClass('js-hide');
    });

    $('.CookiePopUp-impressumState').on('click', function () {
        $('.CookiePopUp-impressumPolicy').toggleClass('js-active');
        $('.CookiePopUp-content').toggleClass('js-hide');
    });

    $('.CookiePopUp-impressumPolicy-back').on('click', function () {
        $('.CookiePopUp-impressumPolicy').toggleClass('js-active');
        $('.CookiePopUp-content').toggleClass('js-hide');
    });

    $('.Search-loadMoreButton').on('click', function () {
        $(this).parent().addClass('js-active');
        $(this).hide();
    });

    if ($('.PowermailMultiForm')) {
        let pages = $(this).find('.PowermailMultiForm-page').length,
            count = 1;

        $('.PowermailMultiForm-button--next').on('click', function () {
            let error;
            $(this).parent().find('.PowermailMultiForm-page.active input[required]').each(function() {
                if($(this).hasClass('powermail_field_error') || $(this).val().length < 0) {
                    error = 1;
                } else {
                    error = 0;
                }
            });

            if(error === 1) {
                $('.PowermailMultiForm-pageError').removeClass('hide');
            } else {
                $('.PowermailMultiForm-pageError').addClass('hide');
                count++;
                pagesElement($(this), count);

                if (count === pages) {
                    $(this).removeClass('active');
                    $(this).prev('.PowermailMultiForm-button--prev').addClass('active');
                } else if (count < pages) {
                    $(this).addClass('active');
                    $(this).prev('.PowermailMultiForm-button--prev').addClass('active');
                }
            }
        });

        $('.PowermailMultiForm-button--prev').on('click', function () {
            count--;
            pagesElement($(this), count);

            if (count === 1) {
                $(this).removeClass('active');
                $(this).next('.PowermailMultiForm-button--next').addClass('active');
            } else if (count < pages) {
                $(this).next('.PowermailMultiForm-button--next').addClass('active');
                $(this).addClass('active');
            }
        });
    }

    function pagesElement(element, count) {
        let pages = element.parent().find('.PowermailMultiForm-page'),
            titles = element.parent().find('.PowermailMultiForm-pageTitle')
        pages.removeClass('active');
        pages.each(function () {
            if (parseInt($(this).attr('data-multiStepForm')) === count) {
                $(this).addClass('active');
            }
        });

        titles.removeClass('active');
        titles.each(function () {
            if (parseInt($(this).attr('data-multiStepFormTitle')) === count) {
                $(this).addClass('active');
            } else if (parseInt($(this).attr('data-multiStepFormTitle')) < count) {
                $(this).addClass('done');
            }
        });
    }

    if($('.PDFBook-pdf')) {
        let pdf = 0
        $('.PDFBook-pdf').each(function () {
        $(this).addClass("pdf-" + pdf);
            $('.pdf-' + pdf).FlipBook({
                pdf: $('.PDFBook-pdf').data('pdfsrc'),
                template: {
                    "html": "/typo3conf/ext/hikoki/Resources/Public/templates/default-book-view.html",
                    "styles": ["/typo3conf/ext/hikoki/Resources/Public/CSS/font-awesome.min.css", "/typo3conf/ext/hikoki/Resources/Public/CSS/black-book-view.css"],
                    "script": "/typo3conf/ext/hikoki/Resources/Public/JS/default-book-view.js"
                },
                controlsProps: {
                    downloadURL: $('.PDFBook-pdf').data('pdfsrc'),
                    actions: {
                        cmdBackward: {
                            code: 37,
                        },
                        cmdForward: {
                            code: 39
                        },
                        cmdSave: {
                            code: 68,
                            flags: 1,
                        }
                    }
                }
            });
            pdf++;
        });
    }
});


$(window).on('load', function () {
    if ($('#dealer_map')) {
        initDealerMap();
    }
});

$(document).click(function (event) {
    let $target = $(event.target);
    if (
        !$target.closest(".Header-mobileSearchWrapper").length &&
        $(".Header-mobileSearchWrapper").hasClass("js-active") &&
        !$target.closest(".Header-mobileSearch").length
    ) {
        $(".Header-mobileSearchWrapper").toggleClass("js-active");
    } else if (
        !$target.closest(".Header-mobileDealerWrapper").length &&
        $(".Header-mobileDealerWrapper").hasClass("js-active") &&
        !$target.closest(".Header-mobileDealer").length
    ) {
        $(".Header-mobileDealerWrapper").toggleClass("js-active");
    } else if (
        !$target.closest(".Header-language-active").length &&
        $(".Header-languageList").hasClass("js-active") &&
        !$target.closest(".Header-languageList").length

    ) {
        $('.Header-languageList').toggleClass('js-active');
    }
});

$(document).ready(function () {
    $('#search_radius').on('change', function () {
        triggerDealerLocatorSearch();
    });

    $('.dealer_type_toggle').on('click', function () {
        triggerDealerLocatorSearch();
    });
});

function triggerDealerLocatorSearch() {
    let input = document.getElementById("search_dealers");
    let place = dealerSearchBox.getPlace();

    if (typeof place === "undefined") {
        return;
    }
    if (!place.geometry || !place.geometry.location) {
        return;
    }

    let lat = place.geometry.location.lat();
    let lon = place.geometry.location.lng();

    let search_radius = document.getElementById("search_radius").value;

    let dealer_type_ids = [];
    $(".dealer_type_toggle").each(function () {
        if ($(this).prop('checked')) {
            dealer_type_ids.push($(this).val());
        }
    });

    let dealer_type_string = encodeURIComponent(dealer_type_ids.join(','));

    dealerAjaxSearch(jQuery(input).data('language-path'), lat, lon, search_radius, dealer_type_string);
}

function dealerLocatorSearchBox() {
    let input = document.getElementById("search_dealers");

    if (!input) {
        return;
    }
    dealerSearchBox = new google.maps.places.Autocomplete(input);
    dealerSearchBox.setFields(['geometry', 'formatted_address', 'name']);
    // searchBox.setComponentRestrictions({'country': ['nl']});

    dealerSearchBox.addListener('place_changed', function () {
        triggerDealerLocatorSearch();
    });
}

function initDealerMap() {
    let div_dealers = document.getElementById("dealer_map");
    if (!div_dealers) {
        return;
    }
    const google_maps_loader = new google.maps.plugins.loader.Loader({
        apiKey: 'AIzaSyDy9pb8J1Cu2yO_q4CYVhGi4BjGwfKfLEk',
        libraries: ["places"]
    });
    google_maps_loader.load().then(() => {
        dealerLocatorSearchBox();
        infoWindow = new google.maps.InfoWindow();

        let latitude = parseFloat($(div_dealers).data('latitude'));
        let longitude = parseFloat($(div_dealers).data('longitude'));
        let zoom_level = parseInt($(div_dealers).data('zoom-level'));
        let input = document.getElementById("search_dealers");
        let search_radius = document.getElementById("search_radius").value;

        let $_GET = retrieveGetParameters();

        if ($_GET.lat && $_GET.lon) {
            latitude = $_GET.lat;
            longitude = $_GET.lon;
            zoom_level = 5;
        } else if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                latitude = position.coords.latitude;
                longitude = position.coords.longitude;
                if (dealerMap) {
                    dealerAjaxSearch(jQuery(input).data('language-path'), latitude, longitude, search_radius, "");
                }
            });
        }

        dealerMap = new google.maps.Map(div_dealers, {
            center: {lat: latitude, lng: longitude},
            zoom: zoom_level
        });
    })
}

function createMarkersFromResponse(dealers) {
    clearDealerMapOverlays();
    var icon = {
        url: '/fileadmin/dealer_icon_1.png',
        scaledSize: new google.maps.Size(49, 52), // scaled size
    };
    for (let i = 0; i < dealers.length; i++) {
        let marker = new google.maps.Marker({
            position: new google.maps.LatLng(dealers[i].lat, dealers[i].lon),
            title: dealers[i].title,
            icon: icon
        });

        marker.addListener('click', function () {
            const dealerId = 'dealer_' + dealers[i].uid;
            let html_string = document.getElementById(dealerId).innerHTML;
            infoWindow.setContent(html_string);
            infoWindow.open(dealerMap, marker);
        });
        // To add the marker to the map, call setMap();
        marker.setMap(dealerMap);
        markersArray[i] = marker;
    }
}

function handleLocationError(browserHasGeolocation, infoWindow, pos) {
    infoWindow.setPosition(pos);
    infoWindow.setContent(browserHasGeolocation ?
        'Error: The Geolocation service failed.' :
        'Error: Your browser doesn\'t support geolocation.');
    infoWindow.open(dealerMap);
}

function clearDealerMapOverlays() {
    for (let i = 0; i < markersArray.length; i++) {
        markersArray[i].setMap(null);
    }
    markersArray.length = 0;
}


function dealerAjaxSearch(lang_path, lat, lon, search_radius, dealer_types) {
    fetch(document.location.origin + lang_path + 'dealer-cards.html?lat=' + lat + '&lon=' + lon + '&search_radius=' + search_radius + '&dealer_types=' + dealer_types, {
        method: 'GET',
        headers: {
            'Accept': 'text/html',
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
    }).then(response => response.json())
        .then(data => {
            if (data.status == 'OK') {
                document.getElementById("dealer_list").innerHTML = data.snippet;
                document.getElementById("DealerResults").innerHTML = data.dealerList;

                if (dealerMap) {
                    createMarkersFromResponse(data.dealers);
                    dealerMap.setCenter(new google.maps.LatLng(lat, lon));
                    dealerMap.setZoom(12); //Should be based on radius
                }
            }
        }).catch((error) => {
        console.error('Error:', error);
    });
}

function retrieveGetParameters() {
    let $_GET = {};
    if (document.location.toString().indexOf('?') !== -1) {
        let query = document.location
            .toString()
            .replace(/^.*?\?/, '')
            .replace(/#.*$/, '')
            .split('&');

        for (let i = 0, l = query.length; i < l; i++) {
            let aux = decodeURIComponent(query[i]).split('=');
            $_GET[aux[0]] = aux[1];
        }
    }
    return $_GET;
}
